import React, { Fragment, useState, FC } from "react";
import UserLink from "../../../utils/UserLink";
import { connect } from "react-redux";
import { useEffect } from "react";
import { resetSelected } from "../../../store/actions/track";
import { firestore } from "../../../firebase";
import { RootState } from "../../../store/reducers";
import { Track } from "../../../models/track";

interface Props {
  selected: Track;
  resetSelected: Function;
  current: Track;
}

const Lyrics: FC<Props> = ({ selected, resetSelected, current }) => {
  let lyr = selected.id === current.id ? current : selected;
  const [lyrics, setLyrics] = useState("");
  const [load, setLoad] = useState(true);
  useEffect(() => {
    let mounted = true;
    document.getElementById("lyrics")?.addEventListener("hidden", () => {
      resetSelected();
    });

    if (mounted) {
      if (lyr.src) {
        firestore
          .collection("lyrics")
          .doc(lyr.id)
          .get()
          .then((resp) => {
            if (resp.exists) {
              if (mounted) setLyrics(resp.data()?.lyrics);
            } else {
              if (mounted) setLyrics("");
            }
            if (mounted) setLoad(false);
          })
          .catch(() => {
            if (mounted) {
              setLoad(false);
              setLyrics("");
            }
          });
      }
    }

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lyr]);

  return (
    <Fragment>
      <div id="lyrics" className="uk-border-rounded" data-uk-modal>
        <div className="uk-modal-dialog">
          <button
            className="uk-modal-close-default"
            type="button"
            data-uk-close
          ></button>

          <Fragment>
            {load ? (
              <span
                className="uk-margin-small-right"
                uk-spinner="ratio: 3"
              ></span>
            ) : (
              <Fragment>
                {lyrics ? (
                  <Fragment>
                    <div className="uk-modal-header">
                      <h5
                        style={{
                          fontSize: `22px`,
                          marginBottom: `10px `,
                        }}
                      >
                        {lyr.title}
                      </h5>

                      <div>
                        <UserLink params={{ username: lyr.username }}>
                          @{lyr.username}
                        </UserLink>
                      </div>
                    </div>

                    <div
                      className="uk-modal-body"
                      data-uk-overflow-auto
                      style={{ maxHeight: `90% !important` }}
                    >
                      {lyrics}
                    </div>
                  </Fragment>
                ) : (
                  <div className="uk-modal-body">
                    <h4>Ooops!, We couldn't find the lyrics you looking for</h4>
                  </div>
                )}
              </Fragment>
            )}
          </Fragment>

          <div className="uk-modal-footer uk-text-right">
            <button
              className="uk-button uk-button-default uk-modal-close"
              type="button"
            >
              CLose
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  selected: state.songs.selected,
  current: state.songs.current,
});

export default connect(mapStateToProps, { resetSelected })(Lyrics);
